import { Component, Input } from '@angular/core';
import { RpaDetailsDto, RpaTypeDto } from '@flyfreely-portal-ui/flyfreely';

@Component({
    selector: 'rpa-list-item',
    templateUrl: './rpa-list-item.component.html',
    styleUrls: ['./rpa-list-item.component.scss']
})
export class RpaListItemComponent {
    @Input() item: RpaDetailsDto;
    @Input() showCustodian = false;
    @Input() showOwner = false;
    @Input() showTypeRequired: RpaTypeDto = null;
}
